import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

export async function getStats() {
  const docRef = doc(db, 'stats', 'statistics'); 
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    throw new Error("Statistics document does not exist in 'stats' collection.");
  }

  const data = docSnap.data();
  // data should have { abonati, total, win, percentage }
  return {
    abonati: data.abonati,
    total: data.total,
    win: data.win,
    percentage: data.percentage
  };
}
